import SettingsIcon from '@material-ui/icons/Settings';
import GET_CLASSROOM_NAME from 'graph/classroom/get-classroom-name-query';
import { RouteId, RouteConfig, GetBreadcrumbsResponse } from 'types';
import AdminClassesStudents from '../AdminClassesStudents';
import AdminClassesStudentsClassroomDetails from '../AdminClassesStudents/ClassroomDetails';
import AdminHelp from '../AdminHelp';
import AdminOrganizations from '../AdminOrganizations';
import AdminProductLicenses from '../AdminProductLicenses';
import AdminProductLicensesOrders from '../AdminProductLicensesOrders';
import AdminRosterManagement from '../AdminRosterManagement';
import AdminUserManagement from '../AdminUserManagement';

const routePrefix = '/admin';
const baseBreadcrumb = {
  name: 'Admin Console',
  path: routePrefix,
  Icon: SettingsIcon
};

const routes: RouteConfig[] = [
  {
    Component: AdminClassesStudents,
    path: '/admin/classes-students',
    getTitle: () => 'Classes & Students',
    getBreadcrumbs: () => [
      baseBreadcrumb,
      { name: 'Classes & Students', path: `${routePrefix}/classes-students` }
    ],
    id: RouteId.ADMIN_CLASSES_STUDENTS,
    privileges: []
  },
  {
    Component: AdminClassesStudentsClassroomDetails,
    path: '/admin/classes-students/:classroomId',
    getTitle: () => 'Classes & Students',
    getBreadcrumbs: ({ match, client }): GetBreadcrumbsResponse => {
      const classroomId = Number(match?.params?.classroomId);
      let result;

      try {
        const data = client.readQuery({
          query: GET_CLASSROOM_NAME,
          variables: { id: Number(classroomId) }
        });

        if (data?.classroom) {
          result = data.classroom;
        }
      } catch {
        // do nothing
      }

      return [
        baseBreadcrumb,
        {
          name: 'Classes & Students',
          path: '/admin/classes-students'
        },
        {
          name: result?.name || 'Students',
          path: `${routePrefix}/classes-students/${classroomId}`
        }
      ];
    },
    id: RouteId.ADMIN_CLASSES_STUDENTS,
    privileges: []
  },
  {
    Component: AdminUserManagement,
    path: '/admin/user-management',
    getTitle: () => 'User Management',
    getBreadcrumbs: () => [
      baseBreadcrumb,
      { name: 'User Management', path: `${routePrefix}/user-management` }
    ],
    id: RouteId.ADMIN_USER_MANAGEMENT,
    privileges: []
  },
  {
    Component: AdminProductLicenses,
    path: '/admin/products-licenses',
    getTitle: () => 'Products & Licenses',
    getBreadcrumbs: () => [
      baseBreadcrumb,
      { name: 'Products & Licenses', path: `${routePrefix}/products-licenses` }
    ],
    id: RouteId.ADMIN_PRODUCT_LICENSES,
    privileges: []
  },
  {
    Component: AdminProductLicensesOrders,
    path: '/admin/products-licenses/orders',
    getTitle: () => 'Activate or Transfer Codes',
    getBreadcrumbs: () => [
      baseBreadcrumb,
      { name: 'Activate or Transfer Codes', path: `${routePrefix}/products-licenses/orders` }
    ],
    id: RouteId.ADMIN_PRODUCT_LICENSES_ORDERS,
    privileges: []
  },
  {
    Component: AdminOrganizations,
    path: '/admin/organizations',
    getTitle: () => 'Organizations',
    getBreadcrumbs: () => [
      baseBreadcrumb,
      { name: 'Organizations', path: `${routePrefix}/organizations` }
    ],
    id: RouteId.ADMIN_ORGANIZATIONS,
    privileges: []
  },
  {
    Component: AdminHelp,
    path: '/admin/help',
    getTitle: () => 'Help for Administrators',
    getBreadcrumbs: () => [
      baseBreadcrumb,
      { name: 'Help for Administrators', path: `${routePrefix}/help` }
    ],
    id: RouteId.ADMIN_HELP,
    privileges: []
  },
  {
    Component: AdminRosterManagement,
    path: '/admin/roster-management',
    getTitle: () => 'Roster Management',
    getBreadcrumbs: () => [
      baseBreadcrumb,
      { name: 'Roster Management', path: `${routePrefix}/roster-management` }
    ],
    id: RouteId.ADMIN_ROSTER_MANAGEMENT,
    privileges: []
  }
];

const getRoutes = (): RouteConfig[] => {
  return routes;
};

export default getRoutes;
